import { Children, useMemo } from "react";
const MULTIPLE_SPACES_REG_EXP = / +/g;
function normalize(text) {
  return text.replace(MULTIPLE_SPACES_REG_EXP, " ").trim();
}
function getChildrenAsLabel(node) {
  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  } else if (node === null || node === void 0 || typeof node === "boolean") {
    return void 0;
  } else if (Array.isArray(node)) {
    return normalize(node.map(getChildrenAsLabel).join(""));
  } else {
    let label = [];
    Children.map(node, (child) => {
      if (child === null || child === void 0 || typeof child === "boolean")
        ;
      else if (typeof child === "string") {
        label.push(child);
      } else if (typeof child === "number") {
        label.push(child);
      } else if (Array.isArray(child)) {
        const childLabel = getChildrenAsLabel(child);
        if (childLabel) {
          label.push(childLabel);
        }
      } else {
        if ("props" in child && "children" in child.props) {
          const childLabel = getChildrenAsLabel(child.props.children);
          if (childLabel) {
            label.push(childLabel);
          }
        } else if ("children" in child) {
          const childLabel = getChildrenAsLabel(child.children);
          if (childLabel) {
            label.push(childLabel);
          }
        } else
          ;
      }
    });
    return label.length > 0 ? label.join("") : void 0;
  }
}
function useChildrenAsLabel(node) {
  return useMemo(() => getChildrenAsLabel(node), [node]);
}
export {
  getChildrenAsLabel,
  useChildrenAsLabel
};
//# sourceMappingURL=useChildrenAsLabel.js.map
